import { Component, Prop, Vue, Mixins, Watch } from 'vue-property-decorator';
import store from "Store/index"
import { mixins } from 'vue-class-component';
import UserMixin from 'Mixins/UserMixin';
import BaseComponent from 'Components/Base/ABaseComponent';
import { OrderingListPendingProductRequestViewModel } from 'Api/CoreApi';
import ApiFactory from 'Api/ApiFactory';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';


@Component({
    template: "#ordering-list-request-product-notification-template"
})
export default class OrderingListRequestProductNotificationComponent extends mixins(BaseComponent,OrderingListUserMixin) {
    
    @Prop({default: false})
    public render: boolean;
    
    
    private notificationElement: HTMLElement;
    
    
    
    async created() {
        
        if(!this.isAdvancedAdmin) return;

        //stop everything
        if(!this.render) return;
        this.setLoading();
        await store.dispatch.orderingListRequestProduct.load({});
        this.setLoaded();

    }
    
    
    update(){
        if(!this.render) return;
        
        this.notificationElement = <HTMLElement>this.$refs.orderingrequestproductnotification;           
        
        //get all a refs by url
        let urlRef = document.getElementById('orderinglistrequestsproduct_link_ref_url').innerHTML;
        if(this.notificationElement == null || urlRef == null) return;
        
        var elements = document.querySelectorAll('a[href="'+urlRef+'"]');
        
        const self = this;
        elements.forEach((elm: HTMLElement, key: number) => {
            if(elm.parentElement.classList.contains('filter-group-item')){
                //insert before elm
                try{
                    elm.parentElement.querySelector('.'+this.notificationElement.classList).remove();
                }catch(e){
                    
                }
                elm.parentElement.insertBefore(this.notificationElement.cloneNode(true), elm); //with all childnodes
            }
            
        });
    }
    
    
    get  list(){
        this.$nextTick(() => {
            this.update();
        });
        return store.state.orderingListRequestProduct.list;
    }
    
    
    get show(){
        return  this.isAdvancedAdmin && this.count > 0;
    }
    
    get count(){
        return this.list ? this.list.length : 0;
    }
    
    
}

Vue.component('ordering-list-request-product-notifcation', OrderingListRequestProductNotificationComponent);